/**
 * Map NMS unit strings (from backend metadata) to display-friendly versions.
 * This is a lightweight module to avoid pulling in heavy dependencies.
 */
export const unitDisplayMap = {
  celsius: '°C',
  fahrenheit: '°F',
  percent: '%',
  bytes: 'bytes',
  connections: 'connections',
  packets: 'packets',
  'packets/sec': 'packets/sec',
  'bits/sec': 'bits/sec',
  s: 's'
};
